import { render, staticRenderFns } from "./ContactWebProfile.vue?vue&type=template&id=2da36e9c&scoped=true"
import script from "./ContactWebProfile.vue?vue&type=script&lang=js"
export * from "./ContactWebProfile.vue?vue&type=script&lang=js"
import style0 from "./ContactWebProfile.vue?vue&type=style&index=0&id=2da36e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da36e9c",
  null
  
)

export default component.exports